import TopupNumber from './general/topup/topupNumber';
import TopupPrices from './general/topup/topupPrices';
import { TopupAmountsViewModel } from './Models/TopupAmountsViewModel';
import { fmComponentsContainer } from './../topic-components';

export default {
    name: "TopupWithPrices",
    template: '#topup-with-prices',
    data: function () {
        return {
            Urls: {
                FetchInitialDataUrl: "/vue/components/topup/prices/fetch"
            },
            FetchInitialDataReady: false,
            componentStyle: "",
            model: {} as TopupAmountsViewModel,
        }
    },
    /* Initial parameters  */
    props: {
        country: String,
        mobileOperator: String,
        header: String,
        currencies: Array<String>
    },
    components: {
        "TopupNumber": TopupNumber,
        "TopupPrices": TopupPrices,
    },
    beforeMount() {
        this.model = new TopupAmountsViewModel();
    },
    mounted() {
        this.fetchInitialData();
    },
    methods: {
        async fetchInitialData() {

            if (this.Urls.FetchInitialDataUrl) {

                if (this.Urls.FetchInitialDataUrl) {
                    await fetch(this.Urls.FetchInitialDataUrl, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            country: this.country,
                            mobileOperator: this.mobileOperator,
                            currencies: this.currencies
                        })
                    })
                        .then(response => {
                            return response.json();
                        })
                        .then(response => {
                            this.model = response;

                            this.FetchInitialDataReady = true;

                            this.handleInitialDataUpdated();
                        });
                }
            }
        },
        handleInitialDataUpdated() {
            if (this.FetchInitialDataReady) {

                var parent = this.$refs.topupWithPricesComponent.parentElement;

                const preloader = parent.querySelector('.component-preloader');

                if (preloader)
                    preloader.remove();

                this.showComponent();
               // this.$refs.topupWithPricesComponent.style.display = "block";
            }
        },
        showComponent() {
            this.componentStyle = "display:block";
        },
    }
}